import { Button, Icon as IconBase, styled } from '@innowise-group/mui-kit';

export const FormContainer = styled.div`
  gap: 0.5rem;
  display: flex;
  flex-direction: column;
`;

export const StepContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const ButtonsSection = styled.div`
  display: flex;
  gap: 0.75rem;
  margin-top: 1rem;
  & > * {
    flex: 1;
  }
`;

export const GrayButton = styled(Button)`
  &.MuiButton-root.MuiButton-outlined {
    color: ${({ theme }) => theme.palette.general.darkGrey[60]};
    border-color: ${({ theme }) => theme.palette.general.darkGrey[60]};
    transition: 0.2s;
  }
  &.MuiButton-root.MuiButton-outlined:hover {
    color: ${({ theme }) => theme.palette.general.darkGrey[80]};
    border-color: ${({ theme }) => theme.palette.general.darkGrey[80]};
  }
`;

export const NonBillableWarning = styled.div`
  display: flex;
  padding: 16px;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  border-radius: 10px;
  border: 1px solid #fee6d8;
  background: #fef2ec;
  color: ${({ theme }) => theme.palette.general.darkGrey[100]};
  font-size: 1rem;
  font-weight: 400;
`;

export const AlertIcon = styled(IconBase)`
  width: 20px;
  height: 20px;
`;
